module.exports = __webpack_public_path__ + "static/img/title-line.79a59e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title-line.png
// module id = m/SZ
// module chunks = 1